<template>
  <ul class="hidden lg:block h-full">
    <li
      v-for="(menuItem, key) in menuItems"
      :key="key"
      v-event-track:myAccountArea.menuItemChosen="{ menu: 'my account', item: menuItem.name }"
      :class="{ active: linksMatch($route.path, menuItem.link), divider: menuItem.has_divider}"
    >
      <a :href="menuItem.link">
        <i
          class="fa-regular"
          :class="menuItem.icon"
        />
        {{ menuItem.text }}
        <span
          v-if="menuItem.isNew"
          class="ml-1 text-xs font-bold text-primary-green"
        >
          NEW
        </span>
      </a>
    </li>
    <li v-if="$store.state.user.isReviewToolsEnabled" class="my-8">
      <SpaceUsage />
    </li>
    <li
      v-for="(footerMenuItem, key) in footerMenuItems"
      :key="`${key}-f`"
      class="footer-li"
    >
      <a :href="footerMenuItem.link">{{ footerMenuItem.text }}</a>
    </li>
  </ul>
</template>
<script>
import SpaceUsage from './space-usage';
import { getMenuItems, getFooterMenuItems } from './get-sidebar-data';

export default {

  components: {
    SpaceUsage,
  },

  data() {
    return {
      menuItems: [],
      footerMenuItems: [],
    };
  },

  async beforeMount() {
    this.menuItems = await getMenuItems(this.$store.getters.userType, this.$store.state.user.isReviewToolsEnabled);
    this.footerMenuItems = await getFooterMenuItems();
  },

  methods: {
    trimSlashes(inputString) {
      return inputString.replace(/^\/|\/$/g, '');
    },
    linksMatch(link1, link2) {
      return this.trimSlashes(link1) === this.trimSlashes(link2);
    },
  },
};
</script>

<style scoped>
.text-\[\#b2b2b2\] {
  color: #b2b2b2;
}

.text-\[\#666666\] {
  color: #666666;
}

.text-\[\#827bff\] {
    color: #827bff;
}

.bg-\[\#f2f2f2\] {
  background-color: #f2f2f2;
}

ul {
  @apply pr-6;
  box-shadow: 10px 4px 6px -7px rgba(0, 0, 0, 0.05);
}

li.divider {
  @apply pb-6 mb-6;
  border-bottom: 1px solid #80808E;
}

li a {
  @apply text-[#b2b2b2] px-4 py-3 block;
}

li a:hover {
  background: rgba(255, 255, 255, 0.12);
  color: white;
}

li.active a {
  background: rgba(255, 255, 255, 0.12);
  color: white;
  border-left: 5px solid #DBFF00;
  
  border-radius: 4px;
}

li a:hover i,
li.active a i {
  @apply font-bold;
}

li i {
  @apply pr-3;
}

.footer-li a {
  @apply py-2;
  font-size: 10px;
  background-color: transparent !important;
}
</style>
